export default __webpack_public_path__ + "static/media/handshake.61a4f43f.svg";